import React from 'react';
import Footer from './inc/Footer/Footer';
import './Landing/Landing.css';

const Layout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className="app-layout">
      <main className="site-main">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
